export const messagesTableauHeader = [
  {
    id: "titre",
    libelle: "Titre",
    isTriable: false,
  },
  {
    id: "contenu",
    libelle: "Contenu",
    isTriable: false,
  },
  {
    id: "dateDebut",
    libelle: "Date de début",
    isTriable: false,
  },
  {
    id: "dateFin",
    libelle: "Date de fin",
    isTriable: false,
  },
  {
    id: "actions",
    libelle: "Actions",
    isTriable: false,
  },
];
